import React, { CSSProperties, ReactElement } from 'react';

import SvgIcon from '@mui/material/SvgIcon';
import styles from './borderedSection.module.css';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme, Tooltip } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

// const borderColor = 'rgba(0, 0, 0, 0.2) !important';
// const oldBorderColor = '#b2b2b2';

export interface BorderedSectionEditSpec<T> {
  editEnabled: boolean | ((model: T) => boolean);
  editIcon?: ReactElement | ((model: T) => ReactElement);
  editTooltip?: string;
  onStart: (model: T) => void;
  onCancel: (model?: T) => void;
  onSave: (model: T) => void;
  onError: (model?: T, error?: string) => void;
}

function BorderedSection<T = undefined>({
  innerRef,
  icon,
  title,
  subTitle,
  subTitleStyle = { fontStyle: 'italic', marginTop: '-2px' },
  children,
  error,
  hint,
  labelStyle,
  style,
  ccStyle,
  labelHeight,
  containerStyle = {},
  className = undefined,
  visible = true,
  compact = false,
  titleBubble = 'none',
  collapsible = false,
  initiallyExpanded = false,
  onExpandToggle = (_expanded: boolean) => {},
  collapsedWidget = undefined,
  expandedIcon = <UnfoldLessIcon style={{ fontSize: '20px' }} />,
  collapsedIcon = <UnfoldMoreIcon style={{ fontSize: '20px' }} />,
  editSpec = undefined,
  actionable = false,
  actionIcon = <EditIcon style={{ fontSize: '20px' }} color="action" />,
  clickAction = () => {},
}: {
  innerRef?: React.RefObject<HTMLDivElement>;
  icon?: React.ElementType;
  title: React.ReactNode;
  subTitle?: string;
  subTitleStyle?: CSSProperties | undefined;
  children: React.ReactNode;
  error?: boolean;
  hint?: string | string[];
  labelStyle?: CSSProperties | undefined;
  style?: CSSProperties | undefined;
  containerStyle?: CSSProperties | undefined;
  ccStyle?: CSSProperties | undefined;
  labelHeight?: string;
  className?: string;
  visible?: boolean;
  compact?: boolean;
  titleBubble?: string;
  collapsible?: boolean;
  initiallyExpanded?: boolean;
  editSpec?: BorderedSectionEditSpec<T> | undefined;
  onExpandToggle?: (expanded: boolean) => void;
  collapsedWidget?: React.ReactNode;
  expandedIcon?: ReactElement;
  collapsedIcon?: ReactElement;
  actionable?: boolean;
  actionIcon?: ReactElement;
  clickAction?: () => void;
}) {
  const [expanded, setExpanded] = React.useState<boolean>(!!initiallyExpanded);

  const theme = useTheme();
  const isSmall = useIsSmallScreen();

  return visible ? (
    <div
      ref={innerRef}
      style={{
        width: '100%',
        marginTop: error ? '0' : '20px',
        ...containerStyle,
      }}
    >
      {subTitle?.length && title && <div style={{ height: '1px' }}>&nbsp;</div>}
      <div
        style={style}
        className={error ? styles.mainContainerError : styles.mainContainer}
      >
        <div className={styles.header}>
          {/*{actionable ? (*/}
          {/*  <div*/}
          {/*    style={{*/}
          {/*      width: '100%',*/}
          {/*      zIndex: 999,*/}
          {/*      position: 'absolute',*/}
          {/*      marginTop: '-11px',*/}
          {/*      right: isSmall ? '26px' : '40px',*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <div*/}
          {/*      style={{*/}
          {/*        display: 'flex',*/}
          {/*        width: '100%',*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <div*/}
          {/*        style={{*/}
          {/*          display: 'flex',*/}
          {/*          flexDirection: 'column',*/}
          {/*          flex: '1 0 auto',*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        &nbsp;*/}
          {/*      </div>*/}
          {/*      <div*/}
          {/*        style={{*/}
          {/*          display: 'flex',*/}
          {/*          flexDirection: 'column',*/}
          {/*          flex: '0 1 auto',*/}
          {/*          backgroundColor: 'white',*/}
          {/*          paddingLeft: '2px',*/}
          {/*          paddingRight: '2px',*/}
          {/*          fontSize: '10px',*/}
          {/*          color: 'darkgrey',*/}
          {/*          border: '1px solid lightgrey',*/}
          {/*          borderRadius: '4px',*/}
          {/*          cursor: 'pointer',*/}
          {/*        }}*/}
          {/*        onClick={clickAction}*/}
          {/*      >*/}
          {/*        {actionIcon}*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*) : null}*/}
          {collapsible && !actionable ? (
            <div
              style={{
                width: '100%',
                zIndex: 999,
                position: 'absolute',
                marginTop: '-11px',
                right: isSmall ? '26px' : '40px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1 0 auto',
                  }}
                >
                  &nbsp;
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '0 1 auto',
                    backgroundColor: '#36AFA5',
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    fontSize: '10px',
                    color: 'white',
                    border: '1px solid lightgrey',
                    borderRadius: '4px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    const newExpanded = !expanded;
                    setExpanded(newExpanded);
                    setTimeout(() => {
                      onExpandToggle(newExpanded);
                    });
                  }}
                >
                  {expanded ? expandedIcon : collapsedIcon}
                </div>
              </div>
            </div>
          ) : null}
          <div
            className={`${error ? styles.headerBorderErrorBefore : styles.headerBorderBefore} borderedSection_header_before`}
          ></div>
          {(icon || title || subTitle) && (
            <div
              className={`${
                titleBubble !== 'none'
                  ? styles.headerTitleBubble
                  : styles.headerTitle
              } borderedSection-header-title`}
              style={{
                ...labelStyle,
                ...(titleBubble !== 'none'
                  ? { backgroundColor: titleBubble }
                  : {}),
                color: error ? '#fff' : '',
                margin: error ? '0px' : '',
                marginTop:
                  subTitle?.length && title ? '-27px' : error ? '0' : '',
                backgroundColor: error ? 'red' : '',
                fontWeight: error ? '600' : '400',
                fontSize: error ? '1em' : '',
                borderRadius: error ? '0' : '',
                border: error ? 'none' : '',
                top: error ? '0' : '',
                left: error ? '0' : '',
                height: error ? '24px' : labelHeight ? labelHeight : 'auto',
                boxShadow: error ? 'none' : 'none',
                borderBottom: 'none',
              }}
            >
              {icon && <SvgIcon component={icon} />}
              {title && (
                <Tooltip title={title}>
                  <>
                    <div
                      style={{
                        position: 'relative',
                        width: '100%',
                        textAlign: 'center',
                        zIndex: 0,
                      }}
                      className={styles.title}
                    >
                      {title}
                    </div>
                  </>
                </Tooltip>
              )}
              {subTitle && (
                <span className={styles.title} style={subTitleStyle}>
                  {subTitle}
                </span>
              )}
            </div>
          )}
          <div
            className={`${
              error ? styles.headerBorderErrorAfter : styles.headerBorderAfter
            } borderedSection_header_after`}
          ></div>
          {actionable && actionIcon ? (
            <>
              <div style={{ flex: '1 0 auto' }}>&nbsp;</div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  transform: 'translate(-10px, -11px)',
                  backgroundColor: '#37aea4',
                  paddingLeft: '2px',
                  paddingRight: '2px',
                  fontSize: '10px',
                  color: 'white',
                  border: '1px solid lightgrey',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                onClick={clickAction}
              >
                {actionIcon}
              </div>
            </>
          ) : null}
        </div>
        <div className={styles.childrenContainer} style={ccStyle}>
          {actionable || !collapsible || expanded
            ? children
            : (collapsedWidget ?? null)}
        </div>
      </div>
      {error && hint && (
        <div
          style={{
            marginTop: '4px',
            marginLeft: '14px',
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontSize: '0.75rem',
            fontWeight: 400,
            color: '#B04C48',
          }}
        >
          {Array.isArray(hint) ? hint.map((h) => <span>{h}</span>) : hint}
        </div>
      )}
    </div>
  ) : null;
}

export default BorderedSection;
